export default __webpack_public_path__ + "static/media/caret-down-black.5a95c0a2.svg";